<template>
  <div class="card">
    <div>
      <h3>生成LoginTicket方法</h3>
      <h4>1.需要准备的数据</h4>
      <table class="param_table">
        <tr>
          <td>加密密钥（secret_key）</td>
          <td>由平台提供</td>
        </tr>
        <tr>
          <td>加密方式</td>
          <td>Des加密算法 CBC加密模式</td>
        </tr>
        <tr>
          <td>偏移量（iv）</td>
          <td>由平台提供</td>
        </tr>
        <tr>
          <td>填充（padmode）</td>
          <td>默认值：PAD_PKCS5</td>
        </tr>
        <tr>
          <td>用户名</td>
          <td>平台用户名</td>
        </tr>
        <tr>
          <td>密码</td>
          <td>平台密码</td>
        </tr>
      </table>
      <h4>2.用户名和密码转化为如下格式JSON字符串</h4>
      <div class="code">
        <p>{"username": "admin", "password": "admin_pass"}</p>
      </div>
      <h4>3.对字符串进行加密</h4>
      <h5>Python示例</h5>
      <div class="code">
        <pre v-highlight>
          <code class="lang-Python">
            import json
            from pyDes import des, CBC, PAD_PKCS5
            import binascii

            ticket_info = {"username": "admin", "password": "admin_pass"}
            des_obj = des('----加密密钥(secret_key)----', CBC, '----偏移(iv)----', pad=None, padmode=PAD_PKCS5)
            secret_bytes = des_obj.encrypt(json.dumps(ticket_info), padmode=PAD_PKCS5)
            print(binascii.b2a_hex(secret_bytes))
          </code>
        </pre>
      </div>
      <h5>C#示例</h5>
      <div class="code">
        <pre v-highlight>
          <code class="lang-c#">
            using System;
            using System.Security.Cryptography;
            using System.IO;
            using System.Text;

            namespace DesTest
            {
              class MainClass
              {
                public static void Main(string[] args)
                {
                  string user_info = "{\"username\": \"admin\", \"password\": \"admin_pass\"}";

                  DESCryptoServiceProvider des = new DESCryptoServiceProvider();
                  des.Mode = CipherMode.CBC;
                  byte[] inputByteArray = Encoding.GetEncoding("UTF-8").GetBytes(user_info);
                  des.Key = ASCIIEncoding.UTF8.GetBytes("----加密密钥(secret_key)----");
                  des.IV = ASCIIEncoding.UTF8.GetBytes("----偏移(iv)----");
                  MemoryStream ms = new MemoryStream();
                  CryptoStream cs = new CryptoStream(ms, des.CreateEncryptor(), CryptoStreamMode.Write);
                  cs.Write(inputByteArray, 0, inputByteArray.Length);
                  cs.FlushFinalBlock();
                  StringBuilder ret = new StringBuilder();
                  foreach (byte b in ms.ToArray())
                  {
                    ret.AppendFormat("{0:X2}", b);
                  }
                  string tcket = ret.ToString();
                  Console.WriteLine(tcket);
                }
              }
            }
          </code>
        </pre>

      </div>
      <h5>JS示例</h5>
      <div class="code">
        <pre v-highlight>
          <code class="lang-javascript">
            &lt;script src="https://cdn.bootcss.com/crypto-js/3.1.9-1/crypto-js.min.js"&gt;&lt;/script&gt;
            &lt;script src="https://cdn.staticfile.org/jquery/1.10.2/jquery.min.js"&gt;&lt;/script&gt;

            &lt;script type="text/javascript"&gt;

              window.onload = function () {
                let source = '{"username": "admin", "password": "admin_pass"}';
                var keyHex = CryptoJS.enc.Utf8.parse('----加密密钥(secret_key)----');
                var ivHex = CryptoJS.enc.Utf8.parse('----偏移(iv)----');
                encrypted = CryptoJS.DES.encrypt(CryptoJS.enc.Utf8.parse(source), keyHex, {
                    iv: ivHex,
                    mode: CryptoJS.mode.CBC,
                    padding: CryptoJS.pad.Pkcs7
                  }
                );
                let ticket =  encrypted.ciphertext.toString();
              }
            &lt;/script&gt;
          </code>
        </pre>
      </div>
      <h3>接口调用</h3>
      <h4>1.调用示例</h4>
      <div class="code">
        <p>http://xa.celer.cc/ticket_login/?ticket=3d337d7bcf3e85b85e8adeac36d21f93be673f********************************************e90cfb677d67c922a916738dc7e3f84db3db7d2ce</p>
      </div>
      <h4>2.结果示例</h4>
      <div class="code">
        <p>{</p>
        <p style="padding-left: 16px">"token": "f275e71***********************05169830"</p>
        <p>}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OpenLogin'
}
</script>

<style scoped>
.card {
  border: 1px solid #eee;
  padding: 20px;
  width: 100%;
  background-color: #fff;
  border-radius: 5px;
  box-sizing: border-box;
  min-height: 265px;
}

p {
  word-wrap: break-word;
  word-break: break-all;
}

a {
  word-wrap: break-word;
  word-break: break-all;
}

div {
  word-wrap: break-word;
  word-break: break-all;
}

.account_table {
  width: 1200px;
  border: 1px solid #aaa;
}

.account_table tr td {
  border: 1px solid #aaa;
  padding: 5px;
}

.account_table tr td:first-child {
  width: 170px;
  background-color: #ddd;
  text-align: center;
}

.param_table {
  width: 800px;
}

.param_table tr td {
  border-bottom: 1px solid #ddd;
  padding: 7px;
}

.param_table tr td:first-child {
  width: 180px;
  text-align: left;
  vertical-align: top;
}

.param_table tr:last-child td {
  border-bottom: none;
}

.code {
  min-height: 50px;
  width: 1200px;
  border: 1px solid #eeeeee;
  border-radius: 5px;
  padding: 8px;
  color: #888;
  background: #eff;
}

h3,
h4,
h5 {
  margin-top: 20px;
  margin-bottom: 10px;
}
.hljs {
  background: none;
}
pre code.hljs {
  padding: 0;
  line-height: 1.8;
}
</style>
